import { render, staticRenderFns } from "./WorkMonthDaysSetupView.vue?vue&type=template&id=8cbfdd5e&scoped=true&"
import script from "./WorkMonthDaysSetupView.vue?vue&type=script&lang=ts&"
export * from "./WorkMonthDaysSetupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbfdd5e",
  null
  
)

export default component.exports